import { Sentry } from '../sentry';

type LogContext = Record<string, unknown>;

export function logError(error: unknown, message?: string, context?: LogContext): void {
  const err = error instanceof Error ? error : new Error(String(error));
  console.error(message ?? err, error);
  Sentry.captureException(err, { extra: { ...context, ...(message ? { message } : {}) } });
}

export function logWarning(message: string, context?: LogContext): void {
  console.warn(message, context ?? '');
  Sentry.captureMessage(message, { level: 'warning', extra: { ...context, ...(message ? { message } : {}) } });
}

export function logInfo(message: string, context?: LogContext): void {
  console.log(message, context ?? '');
}
